var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BackdataCard,{attrs:{"title":'시중노임단가 정보',"headers":_setup.marketWageUnitPriceHeaders,"items":_setup.marketWageUnitPriceData,"openCreateDialog":_setup.openCreateDialog,"openEditDialog":_setup.openEditDialog,"openDeleteDialog":_setup.openDeleteDialog,"loading":_setup.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }